// All editable content in one place.
const B = "https://static.prod-images.emergentagent.com/jobs/0134cf91-1385-4014-b30a-8dd1303a8058/images";
// Locally-generated Golden Observatory imagery (served via FastAPI /api/static)
const L = `${process.env.REACT_APP_BACKEND_URL}/api/static/img`;

export const IMAGES = {
  hero: `${L}/hero.jpg?v=2`,
  about: `${L}/about.jpg?v=2`,
  travel: `${B}/785cb6de85cc260542b460e217a6257929ea2868ae65d7e8117b050004b01593.jpeg`,
  salesforce: `${B}/e7e1fe6cfbec04d63cddf9a774ab585150440b764c02dbaf9b7b5d7bdf2823dc.jpeg`,
  claims: `${B}/ac6b92a877455d1a16118bbfe7947b2fc21f4f5001fba3ff843d833320d6ae0d.jpeg`,
  gift: `${B}/bcb5f747c80d5ad9b884385d3732bfe8c05e7b11992fa88bb91808afdb7a58a6.jpeg`,
  compliance: `${B}/b71f3ee26a53e555dd0550d94b4618c39c3b424915ef1e02563fb47952eee642.jpeg`,
  aerospace: `${L}/aerospace.jpg`,
  sustainability: `${L}/sustainability.jpg`,
  philanthropic: `${L}/philanthropic.jpg`,
  culture: `${L}/culture.jpg`,
  friedman: `${B}/66a4f1e09e120e5d74ec80d91a29a04431f94c4b52eb993e1520c56a8149988e.jpeg`,
  msana: `${B}/2a364b765cf03af0273d603e349437198c287534d24c83674c257192dc207b4f.jpeg`,
  event: `${B}/c37a26eed21ff9fd7faca23c0f1c5cad8d332d76e00fe01a83f9fe0638c25c42.jpeg`,
  contact: `${L}/contact.jpg`,
};

export const PROFILE = {
  name: "Barbara Eliza Betancourt",
  title: "Senior Executive Assistant & Operations Professional",
  email: "bebetancourt96@gmail.com",
  phone: "+1 424-218-0277",
  location: "Playa Vista, CA",
  linkedin: "https://www.linkedin.com/in/barbara-eliza-b-a7b680168",
  site: "bebetancourt.online",
  taglines: [
    "I anticipate the need before it becomes a request.",
    "I build systems that outlast the fire drill.",
    "I treat every organization as my own.",
    "Influence over authority, always.",
  ],
  intro:
    "The person people call when things feel a little too busy, messy, or complicated. Strategic. Intuitive. Relentlessly resourceful. I treat every organization I work with as if it were my own. To me, your success is my success, and I show up every day ready to prove it. For over seven years I have partnered with C-suite leaders across clean energy, insurance, childcare, media, and tech. I turn scattered operations into calm, reliable systems, so the people I support can lead with their full attention.",
  stats: [
    { value: "7+", label: "Years supporting C-suite" },
    { value: "6", label: "Industries" },
    { value: "C-Suite", label: "Trusted partner" },
  ],
};

export const VALUES = [
  "Influence over Authority",
  "Efficiency",
  "Love of Learning",
  "Adaptability",
  "Fun & Fulfillment",
];

export const MARQUEE = [
  "Learn Relentlessly",
  "Influence over Authority",
  "Workflow Designer",
  "People & Project Alchemist",
  "Chief Problem Solver",
  "Strategic Thinker",
  "Culture Curator",
];

export const ACHIEVEMENTS = [
  {
    key: "travel", image: IMAGES.travel,
    leader: "I have three cities in five days and a board dinner in between. Make it seamless.",
    barbara: "Booked. Flights, hotels, and ground transport are locked, your itinerary is on your phone, and I found a smarter routing that trims the spend.",
    metric: "$20K+", metricLabel: "annual travel savings",
    impact: "Coordinated multi-city domestic and international travel with tailored itineraries.",
    company: "London & London", date: "2023-2025",
  },
  {
    key: "salesforce", image: IMAGES.salesforce,
    leader: "The reports are slow and I honestly do not trust the numbers anymore.",
    barbara: "I audited the data, cleaned it, and built custom reports you can rely on. The team is moving through it in a fraction of the time now.",
    metric: "200%", metricLabel: "office efficiency",
    impact: "Audited, cleaned, and rebuilt Salesforce reporting the whole office could trust.",
    company: "London & London", date: "2023-2025",
  },
  {
    key: "claims", image: IMAGES.claims,
    leader: "Claims feel like a black hole. People wait months and nobody owns it.",
    barbara: "I mapped the whole workflow and added a clear owner at every step. The wait dropped from about four months to under ten weeks.",
    metric: "60%", metricLabel: "execution improvement",
    impact: "Redesigned the claims workflow, cutting cycle time from ~4 months to under 10 weeks.",
    company: "Manufacturing Co.", pdfCompany: "Modern Mill", date: "2025-2026",
  },
  {
    key: "gift", image: IMAGES.gift,
    leader: "We are remote and siloed. People feel disconnected from each other.",
    barbara: "I built an optional, inclusive gift exchange from scratch with a fifteen dollar cap. Every single participant said they felt more connected.",
    metric: "100%", metricLabel: "of 45 felt more connected",
    impact: "Launched the first company-wide gift exchange to spark cross-team connection.",
    company: "Manufacturing Co.", pdfCompany: "Modern Mill", date: "2025-2026",
  },
  {
    key: "compliance", image: IMAGES.compliance,
    leader: "The licensing audit is coming and our records are scattered everywhere.",
    barbara: "I built an audit-ready system that stays maintained, not just cleaned up once. We held full regulatory compliance start to finish.",
    metric: "100%", metricLabel: "regulatory compliance",
    impact: "Built an audit-ready records system that stayed maintained over time.",
    company: "Option One Energy", date: "2019-2023",
  },
];

export const EXPERIENCE = [
  {
    company: "Manufacturing Co.", pdfCompany: "Modern Mill", role: "Executive Assistant | Project Manager (Operations & Claims)",
    dates: "2025-2026", industry: "Manufacturing",
    bullets: [
      "Serve as strategic partner and primary point of contact for senior leadership; manage internal and external communications, escalations, and cross-functional coordination.",
      "Coordinate special projects end-to-end across claims, operations, sales, marketing, and quality control, improving execution efficiency by 60%.",
      "Redesigned the claims workflow, reducing cycle time from about four months to under ten weeks.",
      "Execute complex, proactive calendar and meeting management with conflict resolution; protect and optimize executive time.",
      "Own end-to-end office operations, from workplace readiness and conference room and A/V setup to supply and snack inventory and vendor coordination.",
      "Build workflows, custom tools, and SOPs that increase visibility, tracking, and decision-making efficiency across the division.",
      "Administer software and platform accounts, evaluate technology needs, and coordinate with vendors on system access and deployment.",
      "Prepare PowerPoint presentations, reports, and executive materials for internal meetings and external stakeholder briefings.",
      "Support onboarding, HR programs, and culture initiatives; launched the first company-wide gift exchange with 100% of 45 participants reporting they felt more connected.",
    ],
    roles: ["Executive Assistant", "Operations Director", "Project Manager", "Office Manager"],
  },
  {
    company: "London & London Insurance Agency", role: "Executive Assistant | Creative Project Manager",
    dates: "2023-2025", industry: "Insurance",
    bullets: [
      "Served as primary gatekeeper and first point of contact for the CEO/President, managing calendar, correspondence, and triaging all internal and external communications.",
      "Designed operational processes and standardized workflows that reduced administrative lag by 60% across a multi-site portfolio.",
      "Coordinated complex domestic and international travel and itineraries, delivering $20,000+ in annual travel and vendor cost savings.",
      "Curated Salesforce data and custom reports to meet evolving business needs, increasing office efficiency by 200%.",
      "Managed vendor relationships end-to-end: contract file maintenance, renewals, invoice processing, and service performance oversight.",
      "Led training and onboarding of new administrative staff, setting the standard for how information was organized, maintained, and distributed across the team.",
      "Managed daily office operations, including inventory, snacks, conference room readiness, cleaning coordination, and workplace presentation.",
      "Spearheaded the HUGS Committee, planning team events, birthdays, holidays, weekly office treats, and recognition initiatives that strengthened morale.",
      "Produced executive-facing reports and dashboards, synthesizing multi-source data into clear, decision-ready updates.",
    ],
    roles: ["Executive Assistant", "Project Manager", "Administrative Assistant", "Office Manager"],
  },
  {
    company: "Option One Energy", role: "Personal | Executive Assistant",
    dates: "2019-2023", industry: "Clean Energy",
    bullets: [
      "Trusted thought partner to the principal, supporting personal and business functions from a home office environment.",
      "Managed scheduling, correspondence, and priority management for a senior executive operating across multiple business interests.",
      "Tracked expenses, processed invoices, and maintained budget records; coordinated external vendors and service providers.",
      "Built internal tracking systems for recurring administrative tasks, compliance deadlines, and operational action items.",
      "Designed and launched an internship program, leading onboarding, offboarding, and mentorship coordination.",
      "Implemented systematic record-keeping solutions, ensuring 100% regulatory compliance.",
      "Anticipated operational needs and proactively resolved challenges before escalation; handled sensitive personnel and operational information with strict discretion.",
    ],
    roles: ["Personal Assistant", "Executive Assistant", "Administrative Assistant", "Office Manager"],
  },
  {
    company: "Ms. Ana's House Family Child Care", role: "Head Administrator",
    dates: "2012-2023", industry: "Childcare",
    bullets: [
      "Directed all administrative and operational functions for a licensed early childhood program, including regulatory compliance, staff coordination, and family communications.",
      "Managed budget planning, vendor relationships, procurement, and invoice tracking; maintained detailed financial and compliance records.",
      "Developed policies and procedures from the ground up, managing version control and integration into daily practice.",
      "Implemented electronic records systems with naming conventions, filing protocols, and access structures; trained staff for consistent use.",
      "Created and maintained the business website and client scheduling tools; researched and implemented technology solutions that streamlined communications, billing, and daily operations.",
      "Produced family newsletters, enrollment correspondence, and program reports with clear, culturally responsive communication.",
      "Coordinated event planning for families and staff, managing logistics from conception through execution.",
    ],
    roles: ["Office Manager", "Administrative Assistant", "Web Designer"],
  },
  {
    company: "Reasonable Volume (Podcast Production Co.)", role: "Administrative Assistant",
    dates: "2022-2024", industry: "Media",
    additional: true,
    bullets: [
      "Provided administrative support for a podcast production company, coordinating scheduling, correspondence, and production logistics.",
    ],
    roles: ["Administrative Assistant", "Personal Assistant"],
  },
  {
    company: "Bearly (Children's Project)", role: "Co-Writer | Editor | Social Media Manager",
    dates: "2022-2023", industry: "Creative",
    additional: true,
    bullets: [
      "Co-wrote and edited creative content, and managed social media presence for a children's storytelling project.",
    ],
    roles: [],
  },
  {
    company: "Demure (Independent Short Film)", role: "Script Editor | Production Assistant | Cast Member",
    dates: "2021-2022", industry: "Film",
    additional: true,
    bullets: [
      "Supported an independent short film across script editing, on-set production assistance, and on-camera performance.",
    ],
    roles: [],
  },
];

export const ROLES = [
  "Executive Assistant", "Personal Assistant", "Administrative Assistant",
  "Office Manager", "Project Manager", "Operations Director", "Web Designer",
];

export const COMPETENCIES = [
  "Executive & C-Suite support", "Calendar & inbox ownership", "Complex travel coordination",
  "Project & operations management", "Workflow & process design", "Vendor & property management",
  "Event & culture building", "Compliance & records systems", "CRM optimization (Salesforce)",
  "Budget & cost savings", "SOP creation & documentation", "Cross-functional communication",
];

export const TECH_STACK = [
  "Google Workspace", "Microsoft Teams", "Microsoft Forms", "Outlook", "SharePoint",
  "Salesforce", "Slack", "Asana", "Notion", "Todoist", "Monday.com", "Canva",
  "Adobe Acrobat", "Squarespace", "Base44", "ProCare", "Paylocity",
  "ChatGPT", "Claude", "Grok", "Sora", "Leonardo AI", "PhotoRoom",
];

export const IDEAL_SECTORS = [
  { key: "aerospace", title: "Aerospace & Tech", image: IMAGES.aerospace,
    why: "Companies building what hasn't existed before; bold missions, fast-moving teams, and work that actually changes what's possible. I'm drawn to the precision, the pace, and the stakes." },
  { key: "sustainability", title: "Sustainability", image: IMAGES.sustainability,
    why: "Product, service, or both. Having supported clean energy, I love work that leaves the world a little better." },
  { key: "philanthropic", title: "Philanthropic & Impact", image: IMAGES.philanthropic,
    why: "I thrive where the mission is people-first and the impact is felt well beyond the balance sheet." },
  { key: "culture", title: "Culture-Curating Workplaces", image: IMAGES.culture,
    why: "Places that genuinely better the lives of hardworking employees; culture is something you build on purpose." },
];

export const IDEAL_PANELS = [
  { title: "The leader I work best with", body: "I thrive alongside leaders who are visionary but stretched thin; who move fast, think big, and need a true partner rather than an order-taker. The executives I've supported best are the ones who trusted me completely, knowing that when they handed something off, it was handled. If you're the kind of leader who wants someone who will anticipate your next three moves, protect your time fiercely, and push back thoughtfully when something doesn't serve your goals, I'm your person." },
  { title: "The team I thrive in", body: "Small but mighty. Cross-functional by nature. A team where everyone wears more than one hat and nobody says \"that's not my job.\" I love environments where collaboration is genuine, where ideas come from everywhere, and where people actually care about each other's success. Remote, hybrid, or in-person, I adapt easily; what matters most is the culture of accountability and care that exists regardless of where the work happens." },
  { title: "What I'm not looking for", body: "I'm not looking for a role where support means staying invisible. I'm a strategic partner, not a background processor. The best working relationships I've had are ones where my input was genuinely valued. I'm also not the right fit for environments where the status quo is sacred; I will always be looking for the better way, and I need to be somewhere that welcomes that instinct rather than managing it down." },
  { title: "Transferrable Personal Interests", items: [
    { icon: "✈️", label: "Avid Traveler", body: "I've navigated logistics across time zones, cultures, and currencies; which makes me exceptionally good at complex international travel coordination and thinking globally in every context." },
    { icon: "👧", label: "Childcare & Early Education", body: "Running Ms. Ana's House gave me a masterclass in empathy, patience, system-building, and community. Those skills translate directly into people-first operations and exceptional workplace culture." },
    { icon: "🎨", label: "Design & Visual Storytelling", body: "I design websites, build decks, and craft communications that are as visually considered as they are clear. Aesthetics and function aren't at odds for me; I hold both with equal care." },
    { icon: "🎬", label: "Film, Storytelling & Media", body: "From script editing to podcast production, I've worked in creative fields that sharpened my communication instincts, attention to narrative, and ability to collaborate with creative personalities." },
    { icon: "🌿", label: "Wellness & Sustainability", body: "I research health, source intentionally, and live by values that align with the kind of companies I want to support. This isn't a lifestyle trend; it's a lens I bring to everything." },
    { icon: "🧑‍🏫", label: "Mentorship & People Development", body: "I've mentored interns, trained admin staff, and coached aspiring administrative professionals. Helping people grow is one of the most fulfilling things I do, inside and outside of work." },
  ] },
];

export const CASE_STUDIES = [
  {
    key: "gift-exchange",
    title: "The First Company-Wide Gift Exchange",
    subtitle: "Gift Exchange · Manufacturing Co.",
    tagline: "Culture · Program design",
    preview: IMAGES.gift,
    brief: "A roughly 200-person remote company felt siloed and disconnected. Leadership wanted connection without pressure, cost, or exclusion.",
    challenge: "Build something optional and genuinely inclusive from scratch, keep it low-cost, and make remote teammates across the company feel a little closer, without anyone feeling left out.",
    built: [
      { t: "Inclusive framework", d: "An opt-in structure with a $15 cap so cost was never a barrier to joining." },
      { t: "Sign-up & matching", d: "A simple, private way to sign up and get matched, built with Microsoft Forms." },
      { t: "Clear guidelines", d: "Friendly rules on budget, timing, and privacy so everyone knew exactly how it worked." },
      { t: "Shipping logistics", d: "Coordinated addresses and shipping for remote teammates across locations." },
      { t: "Gentle comms", d: "Warm reminders and updates that invited participation without pressure." },
      { t: "Reveal & wrap-up", d: "A celebratory reveal and a feedback loop to capture what worked." },
    ],
    eventImage: IMAGES.event,
    faq: [
      { q: "How it works", a: "Teammates opt in, get privately matched, and send one thoughtful gift within a set budget and timeline." },
      { q: "Shipping", a: "Addresses were collected securely and shipping was coordinated centrally for remote participants." },
      { q: "Privacy", a: "Personal details stayed private and were used only for matching and delivery." },
      { q: "Company values", a: "Optional, inclusive, and low-cost by design, so connection never came at anyone's expense." },
    ],
    result: "100% of the 45 participants said they felt more connected to their colleagues.",
    tools: ["Microsoft Forms", "Outlook", "Slack", "Canva"],
    skills: ["Program design", "Logistics", "Inclusive communication", "Culture building"],
    samples: [
      { kind: "link", label: "Sample of Case Study Project 1 · Website FAQ", url: "https://preview.canva.site/489d4502-fb86-4484-8262-865ebb9ee655/bebetancourt.online/portfolio1" },
      { kind: "file", label: "Sample of Case Study Project 1 · Announcement Flyers", url: "/samples/gift-exchange-flyers.pdf" },
    ],
    confidentiality: "Some details are generalized to respect company and participant privacy.",
  },
  {
    key: "salesforce-turnaround",
    title: "The Salesforce Turnaround",
    subtitle: "Operations · London & London Insurance Agency",
    tagline: "Operations · Systems optimization",
    preview: IMAGES.salesforce,
    brief: "The office was tracking insurance policies, renewals, customer communications and meetings, expirations, deadlines, and policy or customer-info changes across a shared drive folder and a broken CRM setup. An expensive and ineffective use of a powerful tool.",
    challenge: "Turn the scattered, workaround-heavy Salesforce instance into one calm single source of truth, without a rip-and-replace, while making the day-to-day feel lighter for the team.",
    built: [
      { t: "Team-led discovery", d: "Reviewed with the team what info was absolutely required, what we already had, and what nobody was using; gathered a workflow wishlist so every change solved a real problem." },
      { t: "Curated daily reports", d: "Built reports around daily tasks, follow-ups, and statuses so the team saw exactly what needed attention that day." },
      { t: "Leadership dashboard", d: "Constructed a dashboard so leadership could see team performance and overall business health at a glance." },
      { t: "Rebuilt page layouts", d: "Adjusted and created layouts so the info the team searched for lived where it made sense, unlocking the CRM's full power." },
      { t: "Single source of truth", d: "Migrated policy, renewal, communication, expiration, and change records out of the shared drive and into the CRM so nothing lived in two places." },
      { t: "Delight built in", d: "Added confetti and music on task completion so closing out deals felt like a shared win and kept the team uplifted." },
    ],
    eventImage: IMAGES.salesforce,
    faq: [
      { q: "Discovery", a: "Started by mapping what was required, what already existed, and what nobody was using. Then I asked the team what would make their day easier and built around their real wishlist." },
      { q: "Approach", a: "Optimize, don't rebuild. The tool wasn't broken; the way we were asking it to work was." },
      { q: "Team fit", a: "Every layout, report, and dashboard was co-designed with the people using it, then coached in, not dropped on them." },
      { q: "Delight matters", a: "Small human touches count. Confetti and music on task completion turned closing deals into a mini celebration and kept morale high." },
    ],
    result: "200% office efficiency, faster response times on renewals and follow-ups, and a CRM the team actually wanted to use.",
    tools: ["Salesforce", "Excel", "Microsoft Teams", "Outlook", "SharePoint"],
    skills: ["Workflow design", "CRM optimization", "Change management", "Data hygiene", "Team enablement", "Employee morale"],
    confidentiality: "Metrics reflect internal reporting; some workflow details are generalized to respect company privacy.",
  },
];

export const SUPPORTING_PORTFOLIO = [
  { title: "Friedman & Friedman Family Law", tag: "Web Design", image: IMAGES.friedman,
    desc: "Designed and built a warm, trustworthy website for a family law practice." },
  { title: "Ms. Ana's House", tag: "Web Design", image: IMAGES.msana,
    desc: "Created a nurturing, welcoming site for a family childcare home." },
];

export const WORK_TYPES = [
  "Executive support", "Operations & process", "Project management",
  "Event & culture", "Web design", "Other",
];
export const RELATIONSHIPS = [
  "Manager / Executive I supported", "Colleague", "Client", "Direct report", "Other",
];

export const JD_PRESETS = [
  {
    label: "EA to a Tech CEO",
    role: "Executive Assistant",
    text: "We are seeking a Senior Executive Assistant to support the CEO of a fast-growing technology company. Responsibilities include complex calendar and inbox management, coordinating domestic and international travel, preparing leadership meetings, building scalable operational systems, and partnering cross-functionally to drive efficiency. The ideal candidate anticipates needs, protects the executive's time, and thrives in a high-velocity environment.",
  },
  {
    label: "Ops Manager, Sustainability",
    role: "Operations Director",
    text: "A sustainability-focused company is hiring an Operations Manager to design and improve processes across the organization. You will map and streamline workflows, reduce cycle times, manage vendors and budgets, and build compliance and reporting systems. Strong project management, data cleanup, and cross-functional communication are essential. Experience in clean energy or mission-driven organizations is a plus.",
  },
  {
    label: "Program Coordinator, Aerospace",
    role: "Project Manager",
    text: "An aerospace and deep-tech firm seeks a Program Coordinator to keep ambitious technical programs on track. You will coordinate schedules and logistics, own workflow accountability at each step, maintain rigorous documentation and compliance, and communicate clearly across engineering and leadership. Precision, calm under pressure, and a systems mindset are critical.",
  },
];
